import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppForumTopicCreatePage } from './app-forum-topic-create';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppForumTopicCreatePage,
  ],
  imports: [
    IonicPageModule.forChild(AppForumTopicCreatePage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppForumTopicCreatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-forum-topic-create/app-forum-topic-create.module.ts